import { type Delta, type Op } from 'quill';

import type { Guide } from '../guidance/Guide';

export enum GuidanceSessionType {
    FREE_INTRO_SESSION = 'FREE_INTRO_SESSION',
    WELCOME_CALL = 'WELCOME_CALL',
    MEMBER_CALL = 'MEMBER_CALL',
    QUICK_CHECK_IN = 'QUICK_CHECK_IN',
    INVESTMENT_MANAGEMENT = 'INVESTMENT_MANAGEMENT',
    DISCOVERY = 'DISCOVERY',
    ROADMAP = 'ROADMAP', // aka Money Map
    BUILDING_WEALTH = 'BUILDING_WEALTH', // aka Optimization
    REVIEW_CAPSTONE = 'REVIEW_CAPSTONE',
}

export enum GuidanceSessionStatus {
    SCHEDULED = 'SCHEDULED',
    CONFIRMED = 'CONFIRMED',
    COMPLETED = 'COMPLETED',
    CANCELED = 'CANCELED',
    NO_SHOWED = 'NO_SHOWED',
}

export enum GuidanceSessionAutocancelReason {
    NO_SMS_RESPONSE = 'NO_SMS_RESPONSE',
    MEMBERSHIP_CANCELLATION = 'MEMBERSHIP_CANCELLATION',
    SAME_SESSION_TYPE_BOOKED = 'SAME_SESSION_TYPE_BOOKED',
}

export interface GuidanceSession {
    id: string;
    calendlyEventId: string;
    membershipId: string | null;
    startTime: string;
    endTime: string;
    guideId: string;
    guide?: Guide | null;
    type: GuidanceSessionType;
    focus?: string | null;
    videoConferenceUrl: string;
    textReminderNumber?: string | null;
    attendeeTimezone?: string | null;
    calendlyCancelUrl?: string | null;
    calendlyRescheduleUrl?: string | null;
    status: GuidanceSessionStatus;
    confirmationScheduledFor?: string | null;
    confirmationSentAt?: string | null;
    confirmationTwilioSid?: string | null;
    confirmedAt?: string | null;
    canceledAt?: string | null;
    autoCancelReason?: GuidanceSessionAutocancelReason | null;
    createdAt: string;
    updatedAt?: string | null;
    transcriptS3Key?: string | null;
    notes?: string | null;
}

export type RichText = Delta | Op[] | string;
